import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../services/i18nService';
import sessionReader from '../../store/readHelpers/SessionReader';
import dataLoadingService from '../../services/DataLoadingService';
import SketchItem from './SketchItem';
import LoadTracker from '../../services/LoadTracker';
import { VIEW_MEDIA_SCREEN } from '../../constants/SessionConstants';

import styles from './QuestionDisplay.scss';

class ScantronSketches extends React.Component {
    static propTypes = {
        itemResult: PropTypes.object,
        onReady: PropTypes.func.isRequired, // eslint-disable-line react/no-unused-prop-types
        question: PropTypes.object,
        sketchCode: PropTypes.string,
        viewMedia: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);
        this.sketchTrackers = {};
    }

    // eslint-disable-next-line camelcase,react/sort-comp
    UNSAFE_componentWillMount() {
        this.initLoadTracker(this.props);
    }

    componentDidMount() {
        this.renderTracker(true);
    }

    // eslint-disable-next-line camelcase,react/sort-comp
    UNSAFE_componentWillUpdate(nextProps) {
        if (nextProps.question !== this.props.question) {
            this.initLoadTracker(nextProps);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.question !== this.props.question) {
            this.renderTracker(true);
        }
    }

    shouldIncludeLinks(viewMedia) {
        return viewMedia === VIEW_MEDIA_SCREEN;
    }

    getSketches = (includeLinks) => {
        return this.getSketchIds(this.props.itemResult)
            .map((sketchContentItemId, index, array) => {
                return (
                    <SketchItem
                        key={`sketch_${sketchContentItemId}`}
                        includeLink={includeLinks}
                        index={index + 1}
                        totalNumberOfSketches={array.length}
                        sketchContentItemId={sketchContentItemId}
                        onReady={this.sketchTrackers[sketchContentItemId]}
                    />);
            });
    };

    getSketchIds = (itemResult) => {
        if (itemResult && itemResult.responseIdentifiers && itemResult.responseIdentifiers.length > 0) {
            const externalAttachments = itemResult.responseIdentifiers.find((item) => {
                return item.identifier === 'externalAttachment';
            });
            if (externalAttachments && externalAttachments.userResponse && externalAttachments.userResponse.length > 0) {
                return externalAttachments.userResponse;
            }
        }
        return [];
    };

    getQuestionSketchCode = (event) => {
        event.preventDefault();
        dataLoadingService.loadSketchCodeForQuestion(this.props.question.contentRevisionId);
    };

    initLoadTracker(props) {
        const { onReady } = props;
        this.loadTracker = new LoadTracker((success) => {
            if (typeof onReady === 'function') {
                onReady(success, this);
            }
        }, `ScantronSketches for question ${props.question.identifier}`);

        this.renderTracker = this.loadTracker.addItemToTrack('Render ScantronSketches');

        this.getSketchIds(props.itemResult)
            .forEach((sketchId) => {
                this.sketchTrackers[sketchId] = this.loadTracker.addItemToTrack(`Sketch ${sketchId}`);
            });

        this.loadTracker.setAllItemsAdded();
    }

    render() {
        const { sketchCode, viewMedia } = this.props;
        const includeLinks = this.shouldIncludeLinks(viewMedia);
        const sketches = this.getSketches(includeLinks);
        const showSketchCode = !sessionReader.isContextViewGradingQuestionDelivery();

        return (
            <div className={styles.scantronSketchesWrapper}>
                {showSketchCode ?
                    <div className={styles.scantronCodeWrapper}>
                        <div className="question-margin" />
                        <div className={styles.scantronLeft}>
                            <div className={styles.scantronWonder}>{t('question.scantronWonder')}</div>
                            {sketchCode ?
                                <div>{t('question.followInstruction')}</div>
                                :
                                null
                            }
                        </div>
                        <div className={styles.scantronRight}>
                            {sketchCode
                                ? <span className={styles.questionCode}>{sketchCode}</span>
                                : null
                            }
                            {!sketchCode && includeLinks ?
                                (
                                    /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
                                    <a className={styles.showCode} onClick={this.getQuestionSketchCode} href="#">
                                        {t('question.showSketchCode')}
                                    </a>
                                )
                                : null
                            }
                        </div>
                        <div className="question-margin" />
                    </div>
                    : null
                }
                <div className={styles.sketchesDisplay}>
                    {sketches}
                </div>
            </div>
        );
    }
}

export default ScantronSketches;
